import { Component, Prop, h, Element } from '@stencil/core';
import { themes, SpwTheme } from '@themes/themes';

@Component({
  tag: 'spw-theme-provider',
  shadow: false,
})
export class SpwThemeProvider {
  /** Définit le thème employé, conditionne les tokens associés au thème */
  @Prop() theme: SpwTheme = 'rouge';

  @Element() el: HTMLSpwThemeProviderElement;

  componentWillLoad() {
    this.applyTheme(this.theme);
  }

  componentWillUpdate() {
    this.applyTheme(this.theme);
  }

  private applyTheme(theme: SpwTheme) {
    const styleId = 'theme-styles';
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    const css = themes[theme];
    styleElement.innerHTML = css;

    document.documentElement.setAttribute('data-theme', theme);
  }

  render() {
    return (
      <main class={`spw-theme-${this.theme}`}>
        <slot />
      </main>
    );
  }
}
